module.exports = __webpack_public_path__ + "static/img/18wr.91abb6fb.webp";